/* eslint-disable react/jsx-one-expression-per-line */
import React, { ReactElement } from 'react';
import { ErrorPage } from '@components';
import { iCourtFormValues } from '@services/CourtService';
import { useFormikContext } from 'formik';

function CourtErrorPage(): ReactElement {
  const { values }: { values: iCourtFormValues } = useFormikContext();
  return (
    <>
      <ErrorPage errorMessage={values.submissionError} />
    </>
  );
}

export default CourtErrorPage;
